module.exports = __webpack_public_path__ + "static/media/hoverIcon3.30b150cd.png";